import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { servicesData } from '../../mocks/services';
import { useCart } from '../../context/CartContext';

export default function ServicesPage() {
  const { addToCart } = useCart();

  const handleAddToCart = (serviceId: string) => {
    const service = servicesData.find(s => s.id === serviceId);
    if (service) {
      addToCart(service);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary-light to-accent"></div>

        <div className="relative z-10 text-center text-white max-w-3xl mx-auto px-8">
          <h1 className="font-serif text-5xl mb-5">Our Dental Services</h1>
          <p className="text-lg text-white/90">
            Comprehensive care for every stage of life, delivered with expertise and compassion
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-3 gap-8" data-product-shop>
            {servicesData.map((service, index) => {
              const icons = [
                'ri-shield-star-line', 'ri-sparkling-line', 'ri-tools-line',
                'ri-align-center', 'ri-heart-pulse-line', 'ri-first-aid-kit-line',
                'ri-tooth-line', 'ri-stethoscope-line', 'ri-microscope-line'
              ];
              return (
                <div
                  key={service.id}
                  className="group bg-white border-2 border-sand rounded-xl overflow-hidden hover:shadow-lg hover:border-primary/30 transition-all duration-300 cursor-pointer"
                >
                  <div className="bg-gradient-to-br from-sand to-white p-12 flex items-center justify-center">
                    <i className={`${icons[index % icons.length]} text-6xl text-primary group-hover:scale-110 transition-transform`}></i>
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-xl text-navy mb-3">{service.name}</h3>
                    <p className="text-navy/60 text-sm mb-5 leading-relaxed">{service.description}</p>
                    <div className="flex items-center justify-between">
                      <div className="font-serif text-2xl text-primary">${service.price}</div>
                      <button
                        onClick={() => handleAddToCart(service.id)}
                        className="px-6 py-2.5 bg-accent text-white rounded-full text-sm font-medium hover:bg-accent-dark transition-all cursor-pointer whitespace-nowrap"
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-8 bg-sand/30">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-4xl text-navy mb-5">Ready to Get Started?</h2>
          <p className="text-lg text-navy/70 mb-8">
            Schedule your appointment today and take the first step toward a healthier smile
          </p>
          <a
            href="tel:2296519254"
            className="inline-flex items-center px-8 py-4 bg-accent text-white rounded-full font-medium hover:bg-accent-dark transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Book Appointment
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
